import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

export function CollapsibleItem({
	title,
	subtitle,
	badgeRight,
	count,
	open,
	onToggle,
	children,
}: {
	title: string;
	subtitle: string;
	badgeRight: React.ReactNode;
	count: number;
	open: boolean;
	onToggle: () => void;
	children: React.ReactNode;
}) {
	return (
		<div className="rounded-lg border border-gray-200 bg-white">
			<button
				type="button"
				className="w-full text-left"
				onClick={(e) => {
					e.stopPropagation();
					onToggle();
				}}>
				<div className="flex items-start justify-between gap-2 rounded-lg p-2 hover:bg-gray-50">
					<div>
						<p className="truncate text-sm font-semibold text-gray-900">{title}</p>
						<p className="truncate text-xs text-gray-600">{subtitle}</p>
					</div>

					<div className="flex shrink-0 items-center gap-2">
						<span className="rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-700">
							{count}
						</span>

						{badgeRight}

						<ChevronDownIcon
							className={`h-4 w-4 text-gray-500 transition-transform ${open ? "rotate-180" : ""}`}
							aria-hidden="true"
						/>
					</div>
				</div>
			</button>

			{open && <div className="border-t border-gray-200 p-2">{children}</div>}
		</div>
	);
}
